import React from 'react';
import { CtaButton } from './CtaButton';
import { KIT_IMAGE, heroStats } from '../data/content';
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-10 pt-8 sm:px-6 sm:pt-12" data-id="element-152" data-mp="eiboxjpyos8e">
      <div className="mx-auto max-w-3xl text-center" data-id="element-153" data-mp="9k0b6xwjpxkw">
        <div className="mx-auto mb-6 inline-flex items-center gap-2" data-id="element-154" data-mp="9igvp9iprqk6">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500 font-display text-lg font-bold text-white" data-id="element-155" data-mp="4na06ozlls6c">
            K
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-ink sm:text-xl" data-id="element-156" data-mp="xa4j3hgrojhp">
            Dott.ssa <span className="text-brand-500" data-id="element-157" data-mp="sa9qn9hcfluj">Karito</span>
          </span>
        </div>

        <p className="mb-4 text-[11px] font-extrabold uppercase tracking-[0.2em] text-brand-600 sm:text-xs" data-id="element-158" data-mp="ncq4lneem4s1">
          Kit Clinico per la Gestione dell’Obesità
        </p>

        <h1 className="font-display text-[30px] font-extrabold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-159" data-mp="382fedm0930dv">
          Prendi decisioni più rapide e sicure nella gestione dell’obesità{' '}
          <em className="not-italic text-brand-500" data-id="element-160" data-mp="3o7c243hhyzj9">in ogni visita</em>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-[15px] font-medium leading-relaxed text-inksoft sm:text-lg" data-id="element-161" data-mp="3o59a5dwsawbw">
          Segui un Percorso Clinico completo, senza dipendere da molteplici linee guida e senza
          perdere tempo a cercare informazioni durante la visita.
        </p>

        <div className="mt-7" data-id="element-162" data-mp="30fy9rxjcj3ya">
          <img src={KIT_IMAGE} alt="Kit Clinico per la Gestione dell’Obesità: 6 volumi specializzati e materiale digitale" className="mx-auto w-full max-w-[520px]" width={1080} height={1080} data-id="element-163" data-mp="358ho4wpuy345" />
        </div>

        <p className="mx-auto mb-6 max-w-md text-[14px] font-bold leading-snug text-ink sm:text-base" data-id="element-164" data-mp="2vglld8cttotl">
          6 volumi specializzati + materiale digitale per computer, tablet e smartphone
        </p>

        <div id="first-cta" data-id="element-165" data-mp="s21hi9lxc9yx">
          <CtaButton label="Voglio il Kit Clinico ora" note="Oggi solo €19 · Download immediato · Accesso a vita · Garanzia di 7 giorni" data-id="element-166" data-mp="s2b9g2qj4r79" />
        </div>
      </div>

      <div className="mx-auto mt-10 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-167" data-mp="ibgm0v1jrlk8">
        {heroStats.map(stat => <div key={stat.label} className="rounded-2xl border border-brand-100 bg-white px-3 py-4 text-center" data-id="element-168" data-mp="deq8ofh4n42i">
            <p className="font-display text-2xl font-bold leading-none text-brand-500 sm:text-3xl" data-id="element-169" data-mp="1622idp26vhee">
              {stat.value}
            </p>
            <p className="mt-2 text-[10px] font-bold uppercase leading-tight tracking-wider text-inksoft sm:text-[11px]" data-id="element-170" data-mp="111eqz2a1syjn">
              {stat.label}
            </p>
          </div>)}
      </div>
    </header>;
}